<template>
  <div>
    <div
      class="flex items-center w-full relative rounded-2xl hover:cursor-pointer"
      @click="navigate(resource.resourceTranslations[0]?.resourceUrl)"
    >
      <img
        v-if="!isYoutubeVideoLink(resource.resourceTranslations[0]?.resourceUrl)"
        class="rounded-[8px] w-1/2 sm:w-[272px] sm:h-[150px] flex-none"
        :src="resource.thumbnail"
        :alt="resource.title"
      />
      <YoutubeInAppBrowser
        v-else
        :video-id="getYoutubeId(resource.resourceTranslations[0]?.resourceUrl)"
        :video-url="resource.resourceTranslations[0]?.resourceUrl"
        :poster-url="resource.thumbnail"
        :is-dark-button="true"
        :preferred-caption="null"
        customClass="w-full sm:h-[150px] sm:w-[272px] rounded-[8px]"
        class="w-1/2 sm:w-[272px] sm:h-[150px] flex-none"
      />
      <div class="flex-1 flex flex-col justify-center">
        <p
          class="font-aktiv-grotesk-medium leading-[20px] text-[16px] md:text-md lg:text-lg truncate-sm ml-3"
        >
          {{ getTitle() }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Browser } from '@capacitor/browser';
import YoutubeInAppBrowser from '@/components/ResourcesPage/PlaybackResources/YoutubeInAppBrowser.vue';
import { isYoutubeVideoLink, getYoutubeId } from '@/utils/youtube';

export default {
  components: {
    YoutubeInAppBrowser,
  },
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showLanguageModal: false,
      downloadTypes: ['PDF', 'Excel'],
      articleTypes: ['Link', 'Article'],
    };
  },
  computed: {
    modalType() {
      if (this.resource.type === 'video') return 'video';
      else if (this.downloadTypes.includes(this.resource.type)) return 'download';
      else return 'link';
    },
  },
  methods: {
    getTitle() {
      return this.resource.title;
    },
    openLanguageModal() {
      if (this.resource.resourceTranslations && this.resource.resourceTranslations.length > 1) {
        this.showLanguageModal = true;
      }
    },
    closeLanguageModal() {
      this.showLanguageModal = false;
    },
    navigate(url) {
      if (isYoutubeVideoLink(url)) return;
      this.openLanguageModal();
      if (!this.showLanguageModal) {
        const translation = this.resource.resourceTranslations[0];
        const type = this.resource.type;
        if (
          (type === 'sm_others' || type === 'sm_tools') &&
          this.isAppRoute(translation.resourceUrl)
        ) {
          this.$router.push(translation.resourceUrl);
        } else if (translation.isExternal && !isYoutubeVideoLink(translation.resourceUrl)) {
          Browser.open({ url: translation.resourceUrl });
        } else {
          // assume it is a video
          this.$router.push(`/resources/video/${this.resource.slug}`);
        }
      }
    },
    isAppRoute(url) {
      return url?.startsWith('/');
    },
    isYoutubeVideoLink,
    getYoutubeId,
  },
};
</script>

<style scoped>
.truncate-sm {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
